import { useEffect } from 'react';

const LANGS = ['de', 'en', 'fr', 'it', 'es', 'pt', 'nl', 'pl', 'da', 'sv', 'fi', 'tr', 'ru', 'ar', 'he', 'fa', 'ku', 'hi', 'zh', 'ja'];

const setMeta = (attr, key, value) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement('meta'); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute('content', value);
};

// Injects Organization / TaxiService / WebSite JSON-LD with absolute URLs (for Google logo & AI crawlers).
const SiteSchema = () => {
  useEffect(() => {
    const o = window.location.origin;
    const org = { '@type': 'Organization', '@id': `${o}/#organization`, name: 'CAB.TAXI', alternateName: 'Cab Taxi Zürich', url: `${o}/`,
      logo: { '@type': 'ImageObject', url: `${o}/logo.png`, width: 512, height: 512 }, image: `${o}/og-image.jpg`,
      telephone: '+41791772424', email: 'info@cab.taxi',
      address: { '@type': 'PostalAddress', streetAddress: 'Blumenfeldstrasse 1', postalCode: '8046', addressLocality: 'Zürich', addressCountry: 'CH' },
      contactPoint: { '@type': 'ContactPoint', telephone: '+41791772424', contactType: 'customer service', availableLanguage: ['de', 'en', 'fr', 'it'], areaServed: 'CH' } };
    const service = { '@type': 'TaxiService', '@id': `${o}/#service`, name: 'CAB.TAXI Airport Transfer', provider: { '@id': `${o}/#organization` },
      serviceType: 'Airport taxi & private transfer', url: `${o}/booking`,
      areaServed: [{ '@type': 'Country', name: 'Switzerland' }, { '@type': 'Airport', name: 'Zürich Airport', iataCode: 'ZRH' }, { '@type': 'Airport', name: 'EuroAirport Basel', iataCode: 'BSL' }, { '@type': 'Airport', name: 'Geneva Airport', iataCode: 'GVA' }],
      availableChannel: { '@type': 'ServiceChannel', serviceUrl: `${o}/booking`, servicePhone: '+41791772424' },
      offers: { '@type': 'Offer', priceCurrency: 'CHF', price: '60', description: 'Festpreis ab CHF 60 · Economy ab CHF 2.40/km' } };
    const site = { '@type': 'WebSite', '@id': `${o}/#website`, url: `${o}/`, name: 'CAB.TAXI', publisher: { '@id': `${o}/#organization` }, inLanguage: LANGS };
    let el = document.getElementById('site-schema');
    if (!el) { el = document.createElement('script'); el.type = 'application/ld+json'; el.id = 'site-schema'; document.head.appendChild(el); }
    el.textContent = JSON.stringify({ '@context': 'https://schema.org', '@graph': [org, service, site] });
    setMeta('property', 'og:image', `${o}/og-image.jpg`);
    setMeta('name', 'twitter:image', `${o}/og-image.jpg`);
    setMeta('property', 'og:url', `${o}${window.location.pathname}`);
  }, []);
  return null;
};

export default SiteSchema;
